import BASEURLPROJETOS from '../api/projetos'
import { CadastrarIndicadorMensuracaoPayload, AtualizarIndicadorMensuracaoPayload } from "../../interfaces/indicadorMensuracao"


export function cadastrarIndicadorMensuracao(payload: CadastrarIndicadorMensuracaoPayload) {
  return BASEURLPROJETOS.post(`/mensuracao`, payload);
}

export function atualizarIndicadorMensuracao(idMensuracao: string, payload: AtualizarIndicadorMensuracaoPayload) {
  return BASEURLPROJETOS.patch(`/mensuracao/${idMensuracao}`, payload);
}

export function deletarIndicadorMensuracao(idIndicadorMensuracao: string) {
  return BASEURLPROJETOS.delete(`/mensuracao/${idIndicadorMensuracao}`);
}